import React from 'react';
import { GiftIcon, StarIcon } from 'lucide-react';
import { Section, SectionTitle } from '../Section';
import { CtaBlock } from '../CtaBlock';
import { bonuses } from '../../data/content';
export function Bonuses() {
  return <Section data-id="element-89" data-mp="1clzeqq4qz26l">
      <SectionTitle eyebrow="🎁 And you’ll get these 5 exclusive bonuses free" subtitle="5 bonus tools to help you get more from your welding skills" data-id="element-90" data-mp="1clfu31nppzov">
        5 Exclusive Bonuses
      </SectionTitle>

      <ul className="mt-8 space-y-4" data-id="element-91" data-mp="257hcvc0fgzr2">
        {bonuses.map(bonus => <li key={bonus.number} className={`grid gap-5 rounded-2xl border p-4 sm:p-5 lg:grid-cols-[minmax(0,420px)_minmax(0,1fr)] lg:items-center lg:gap-7 ${bonus.featured ? 'border-teal-bright/60 bg-teal/[0.08]' : 'border-white/10 bg-ink-800'}`} data-id="element-92" data-mp="20bjw54l95rdr">
            <img src={bonus.image} alt={`${bonus.title} bonus digital pack cover`} className="mx-auto w-full max-w-none" width={1240} height={1240} loading="lazy" data-id="element-93" data-mp="fv6xvq9zp63r" />

            <div data-id="element-94" data-mp="1jqni2laj6iey">
            <div className="flex flex-wrap items-center gap-2" data-id="element-95" data-mp="1jqdo6mmd7r3z">
              <span className="inline-flex items-center gap-1.5 rounded-md bg-teal/20 px-2 py-1 text-[11px] font-extrabold uppercase tracking-wider text-teal-bright" data-id="element-96" data-mp="15sgqto037go9">
                <GiftIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-97" data-mp="w2x6sf0n1grt" />
                Bonus {bonus.number}
              </span>
              {bonus.featured ? <span className="inline-flex items-center gap-1 rounded-md bg-ember/20 px-2 py-1 text-[11px] font-extrabold uppercase tracking-wider text-ember" data-id="element-98" data-mp="10vqaczkdej2b">
                  <StarIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-99" data-mp="r4lxc5e998a4" />
                  Most used
                </span> : null}
              <span className="ml-auto text-[12px] font-extrabold uppercase tracking-wider text-white/45" data-id="element-100" data-mp="i3e9kh9d7pua">
                Value: <s data-id="element-101" data-mp="2jt3gg6qumk04">{bonus.value}</s>{' '}
                <span className="text-teal-bright" data-id="element-102" data-mp="2ju4py6s7uyfq">Free</span>
              </span>
            </div>

            <h3 className="mt-3 font-display text-xl font-bold uppercase leading-tight text-white sm:text-2xl" data-id="element-103" data-mp="2f0a7f6ockpi8">
              {bonus.title}
            </h3>
            <p className="mt-1 text-[15px] font-semibold leading-snug text-teal-bright" data-id="element-104" data-mp="261otjottlyns">
              {bonus.headline}
            </p>
            <p className="mt-2 text-[15px] leading-snug text-white/65" data-id="element-105" data-mp="32qw6w9kad1gm">
              {bonus.description}
            </p>
            </div>
          </li>)}
      </ul>

      <CtaBlock className="mt-10" headline="Claim the 6 manuals + all 5 bonuses today" data-id="element-106" data-mp="2tpol2qyyht3f" />
    </Section>;
}